import {
    useMutation,
    useQueryClient
} from "react-query";
import {CERTIFICATES_ALL_QUERY_KEY} from "./useCertificates";
import {deleteCertificate} from "../../../services/api/certificates";
import {COMPANY_USER_CERTIFICATES_ALL_QUERY_KEY} from "../company-user-certificates/useCompanyUserCertificates";

export const useDeleteCertificate = () => {
    const queryClient = useQueryClient();

    return useMutation(
        {
            mutationFn: ({id}: {
                id: number
            }) => deleteCertificate(id),
            onSuccess: (data, variables, context) => {
                queryClient.invalidateQueries(CERTIFICATES_ALL_QUERY_KEY);
                queryClient.invalidateQueries(COMPANY_USER_CERTIFICATES_ALL_QUERY_KEY);
            }
        }
    );
};
